import React, { Fragment, useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Benefits from "./benefits";
import ServiceSidebar from "./sidebar";
import Footer from "../../components/footer/Footer.js";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ServiceSinglePage = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [services, setServices] = useState([]);

  useEffect(() => {
    const getServices = async () => {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/service`);
      setServices(res.data.data);
    };
    getServices();
  }, []);

  const serviceDetails = services.find((item) => item.id === Number(id));

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <Fragment>
      <Navbar hclass={"wpo-header-style-5"} />
      <PageTitle pageTitle={`${serviceDetails?.name}`} pagesub={"Service"} />
      <section className="wpo-service-single-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-12">
              <div className="wpo-service-single-wrap">
                <div className="wpo-service-single-img">
                  <img src={serviceDetails?.image} alt="" />
                </div>
                <div className="wpo-service-single-content">
                  <div className="wpo-service-single-content-des">
                    <h2>{`${serviceDetails?.name}`}</h2>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: serviceDetails?.description,
                      }}
                    ></p>

                    <div className="wpo-service-single-sub-img">
                      <ul>
                        <li>
                          <img src={serviceDetails?.ssImg1} alt="" />
                        </li>
                        <li>
                          <img src={serviceDetails?.ssImg2} alt="" />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="wpo-related-section">
                  <h2>Related Service</h2>
                  <div className="row">
                    {services.slice(0, 3).map((service, Sitem) => (
                      <div
                        className="col-lg-4 col-md-6 col-12"
                        key={Sitem}
                        onClick={() =>
                          navigate(`/service-single/${service.id}`)
                        }
                      >
                        <div className="wpo-related-item">
                          <div className="wpo-related-icon">
                            <div className="icon">
                              <i>
                                <img src={service?.image} alt="" />
                              </i>
                            </div>
                          </div>
                          <div className="wpo-related-text">
                            <h3>
                              <Link
                                onClick={ClickHandler}
                                to={`/service-single/${service.id}`}
                              >
                                {service?.name}
                              </Link>
                            </h3>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: service?.description.slice(0, 120),
                              }}
                              className="text-truncate"
                            ></p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <Benefits />
              </div>
            </div>
            <ServiceSidebar services={services} />
          </div>
        </div>
      </section>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ServiceSinglePage;
